import {ReactComponent as LogoMin}  from '@/assets/images/logo/logo-simple.svg';
import {ReactComponent as Logo}  from '@/assets/images/logo/logo-titulo.svg';

export const application = {
  name: 'Oficina Virtual Aguas de la Habana',
  mobileName: 'Oficina Virtual',
  logo: {
    src: Logo,
    srcMin: LogoMin
  }
};
